var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.44 4.622-3.17 14.944c-.238 1.054-.862 1.317-1.748.82l-4.828-3.558-2.33 2.24c-.258.258-.473.474-.97.474l.347-4.917 8.948-8.086c.39-.347-.084-.54-.604-.192L7.022 13.312l-4.762-1.49c-1.036-.324-1.055-1.036.215-1.533l18.628-7.177c.863-.323 1.617.193 1.336 1.51Z",
    fill: "currentColor"
  })));
};
export default SvgTelegram;